<template>
  <div>
    <v-card v-if="dataOnlyZeros === 0" class="mb-4">
      <v-card-title class="pt-4">
        <v-container class="pa-0" fluid fill-height>
          <span class="pa-1 section-title">Hora</span>
        </v-container>
      </v-card-title>
      <v-card-text>
        <v-layout class="pb-4" justify-center>
          <span class="body-2">Não há dados</span>
        </v-layout>
      </v-card-text>
    </v-card>
    <chart-card v-else title="Hora" :data="chartData" :controls="false" :loader="loader" is-integer />
  </div>
</template>

<script>
import orderBy from 'lodash/orderBy'
import ChartCard from '@/components/ChartCard.vue'
import { colors } from '@/config/colors.js'

export default {
  components: {
    ChartCard,
  },
  props: {
    data: Array,
    module: String,
  },
  computed: {
    loader() {
      if (this.module === 'clientes') return ['clientes-horas-maiores-compras']
      if (this.module === 'produtos') return ['produtos-horas-maiores-compras']
      return ''
    },
    horaData() {
      return orderBy(this.data, 'NUM_HORA', 'asc')
    },
    dataOnlyZeros() {
      return this.data.reduce((accum, object) => {
        return accum + object['NUM_TOTAL_CUPONS']
      }, 0)
    },
    chartData() {
      return {
        labels: [...this.horaData.map((object) => object['NUM_HORA'] + ':00')],
        datasets: [
          {
            label: 'Cupons',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...this.horaData.map((object) => object['NUM_TOTAL_CUPONS'])],
            fill: false,
          },
        ],
      }
    },
  },
}
</script>
